import * as React from 'react';

import * as styles from './styles.css';
import { IOffersHistoryProps } from './types';

export const OffersHistory: React.FC<IOffersHistoryProps> = props => {
  return (
    <div>
      <div className={styles['filters']}>{props.filters}</div>

      {props.moreDetailed}

      <div className={styles['feed']}>{props.feed}</div>

      {props.showMoreBtn}
    </div>
  );
};
